<template>
  <v-card
    v-scroll.self="onChatScroll"
    class="overflow-y-auto chat-list"
    :height="chatHeight"
    tile
    light
    ref="me"
    width="100%"
  >
    <v-card-text ref="content" :class="(autoScrollLock ? 'autoScrollLocked ' : 'autoScrollEnabled ') + contentClasses">
      <div v-for="group in groupedConversation" :key="group.key" class="pb-1">
        <chat-message
          v-for="(chatMessage, index) in group.messages"
          :key="chatMessage.id"
          v-on:userNameClicked="onMessageUserNameClicked(chatMessage)"
          :message="chatMessage"
          :groupIndex="index"
          :isAdminMessage="chatMessage.isAdmin == true"
        />
      </div>
    </v-card-text>
    <player-profile-dialog
      v-if="showProfileUser"
      :user="showProfileUser"
      :visible="true"
      :closeAction="function () {showProfileUser = null;}"
    ></player-profile-dialog>
  </v-card>
</template>

<script>
import Vue from "vue";
import ChatMessage from "@/widgets/ChatMessage";
import PlayerProfileDialog from "@/widgets/PlayerProfileDialog";

export default {
  name: "ChatHistory",
  components: {
    ChatMessage,
    PlayerProfileDialog,
  },
  props: {
    conversation: {
      type: Array,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    scrollToEndTrigger: {
    },
    height: {
      default: null
    }
  },
  data: function () {
    return {
      profileUID: undefined,
      windowHeight: 0,
      chatWidth: 0,
      showProfileUser: null,
      autoScrollLock: false,
    };
  },
  computed: {
    reversedConversation() {
      if (!this.conversation) {
        return [];
      }
      return this.conversation.slice().reverse();
    },
    groupedConversation() {
      let ret = this.reversedConversation.reduce(function (r, msg) {
        if (r.length == 0 || r[r.length - 1].userUID != msg.userUID) {
          r.push({
            key: "group_" + msg.id,
            userUID: msg.userUID,
            username: msg.username,
            messages: [],
          });
        }
        r[r.length - 1].messages.push(msg);
        return r;
      }, []);
      return ret;
    },
    chatHeight() {
      if(this.height){
        return this.height
      }
      if (this.windowHeight > 0 && this.$refs.me) {
        let top = this.$refs.me.$el.getBoundingClientRect().top;
        let h = this.windowHeight - top - 150;
        if (h < 10) {
          h = 10;
        }
        return h + "px";
      }
      return "30vh";
    },
    contentClasses() {
      if (this.chatWidth < 340) {
        return 'pl-0'
      }
      return ''
    }
  },
  watch: {
    conversation: function () {
      // When conversation has changed, scroll to the end
      if (!this.autoScrollLock) {
        this.scrollChatToEnd();
      }
    },
    autoScrollLock: function(val) {
      this.$emit("autoScrollLockChanged", { autoScrollLock: val });
    },
    scrollToEndTrigger: function() {
      // console.log('scrollToEnd triggered')
      this.scrollChatToEnd()
    }
  },
  mounted() {
    this.scrollChatToEnd();
    this.profileUID = this.$store.state.profile.uid;
    this.windowHeight = window.innerHeight;
    this.chatWidth = this.$refs.me.$el.clientWidth
    this.$nextTick(() => {
      window.addEventListener("resize", this.onWindowResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onWindowResize);
  },
  methods: {
    onMessageUserNameClicked: function(msg) {
      console.log(msg)
      let player = {uid: msg.userUID, name: msg.username}
      this.showProfileUser = player
    },
    onWindowResize: function () {
      this.windowHeight = window.innerHeight;
      this.chatWidth = this.$refs.me.$el.clientWidth
    },
    scrollChatToEnd: function () {
      Vue.nextTick().then(() => {
        let chat = this.$refs.me.$el;
        chat.scrollTop = chat.scrollHeight;
      });
    },
    onChatScroll() {
      // console.log('onChatScroll')
      let scrollBottom = this.$refs.me.$el.clientHeight + this.$refs.me.$el.scrollTop;
      let scrollOffset = scrollBottom - this.$refs.content.clientHeight; // 0 when at the bottom of the chat. Negative when scrolled up. Positive when the content is pushed up (temporarily)
      // console.log('scrollOffset', scrollOffset)
      if (this.$refs.me.$el.scrollTop < 15 && !this.loading) {
        // console.log("TODO: load older messages here. Needs to be debounced, perhaps.");
      }
      if (scrollOffset < -40) {
        this.autoScrollLock = true; // lock auto scrolling
      } else if (scrollOffset >= -20) {
        this.autoScrollLock = false; // unlock/enable auto scolling
      }
    },
  },
};
</script>

<style scoped>
.chat-list {
  background-color: transparent;
}
.autoScrollLocked {
  border-left:solid var(--v-accent-base) 1px;
}
.autoScrollEnabled {
  border-left:solid transparent 1px;
}
</style>


